
import Container from 'react-bootstrap/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ProctorAvailabilityDashboard from './ProctorAvailabilityDashboard';
import FacultyApprovalDashboard from './FacultyApprovalDashboard';
import { RolesDragdown } from '../ui/RolesDragdown';
import { useEffect, useState } from 'react';

function AdministratorDashboard() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("faculty-approval");

  useEffect(() => {
    if (location.state?.toProctor) {
      setActiveTab("proctorAvailability");
    }
  }, [location]);

  return (
    <Container fluid className="dashboard-container py-5">
      {/* Header */}
      <h2 className="text-center mb-4">Admin Dashboard</h2>

      {/* Roles Dropdown */}
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <RolesDragdown />
      </div>

      {/* Tabs Section */}
      <Tabs
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key)}
        id="admin-dashboard-tabs"
        className="mb-4 custom-tabs"
        fill
      >
        {/* Faculty Approval Tab */}
        <Tab eventKey="faculty-approval" title="Faculty Approval" className="custom-tab-content">
          <FacultyApprovalDashboard />
        </Tab>

        {/* Proctor Availability Tab */}
        <Tab eventKey="proctorAvailability" title="Proctor Availability" className="custom-tab-content">
          <ProctorAvailabilityDashboard />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default AdministratorDashboard;
